export class NewPassword {
    token:string;
    newPassword:string;
    confirmPassword:string;

    constructor(newPassword:any) {
        this.token = newPassword.token;
        this.newPassword = newPassword.newPassword;
        this.confirmPassword = newPassword.confirmPassword;
    }
}